import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editWorkstationDialog from '../dialog.editWorkstationDialog';
import controller from './workstation.controller';
import directive from './workstation.directive';


export default angular.module('app.components.advisory.bcp.workstation', [
  alerts,
  bcpDataService,
  confirmDialog,
  constants,
  editWorkstationDialog,
  ssDialogService,
])
  .directive('bcpWorkstation', directive)
  .controller('WorkstationController', controller)
  .name;

console.log('app.components.advisory.bcp.workstation created');
